import context from '../context'
import commonErrorHandler from '@/utils/errors'
import getComponentKey from '@/utils/getComponentKey'
import values from 'lodash/values'
import maxBy from 'lodash/maxBy'
import orderBy from 'lodash/orderBy'

const initialState = {
  fetching: false,
  items: [],
  componentKey: getComponentKey()
}

const actionTypes = {
  Fetching: 'reportTemplateSelector/fetching',
  Fetched: 'reportTemplateSelector/fetched',
  Error: 'reportTemplateSelector/error'
}

const handleError = (details) => commonErrorHandler(actionTypes.Error, details)

export const actionCreators = {
  getSelectorData: (reportType) => (dispatch, getState) => {
    dispatch({ type: actionTypes.Fetching })
    context.api.reportTemplateService.getTemplatesSelector(reportType, {})
      .then(response => {
        const data = prepareSelectorData(response)
        dispatch({ type: actionTypes.Fetched, data })
      })
      .catch(error => handleError({ dispatch, error, update: { fetching: false } }))
  }
}

function prepareSelectorData (response) {
  const categories = {}
  response.data.forEach(item => {
    const category = categories[item.categoryId] || {
      templates: [],
      id: item.categoryId,
      name: item.category,
      latinName: item.latinCategory,
      totalCount: 0
    }
    // Transformation to origin structure
    const currentVersion = maxBy([...item.versions], 'version')
    category.templates.push({ ...item, ...currentVersion })
    category.totalCount = category.totalCount + 1
    categories[item.categoryId] = category
  })

  // Sort templates
  Object.keys(categories).map((key) => {
    categories[key].templates = orderBy([...categories[key].templates], ['order'], ['asc'])
  })

  return values(categories)
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.Fetching: return { ...state, fetching: true }
    case actionTypes.Fetched: return { ...state, fetching: false, componentKey: getComponentKey(), items: action.data }
    case actionTypes.Error: return { ...state, ...action.data }

    default: return state
  }
}



// WEBPACK FOOTER //
// ./src/store/ReportTemplateSelector.js